function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.3106 6.6588C27.2429 7.39274 26.06 7.95498 24.8076 8.32384C24.1332 7.57567 23.2379 7.04639 22.243 6.80758C21.2481 6.56877 20.2014 6.63196 19.2446 6.98861C18.2879 7.34525 17.4671 7.97813 16.8934 8.80167C16.3197 9.6252 16.0206 10.5996 16.0368 11.5932L16.0394 12.676C14.0767 12.73 12.1308 12.3127 10.375 11.4611C8.6191 10.6096 7.1078 9.35026 5.97565 7.79529C5.97565 7.79529 1.53158 17.5508 11.5939 21.8576C9.29737 23.3768 6.55908 24.1423 3.78097 24.0419C13.8459 29.4315 26.1186 23.9882 26.0886 11.5365C26.0869 11.235 26.0562 10.9342 25.9971 10.6381C27.1344 9.54554 27.9355 8.16767 28.3106 6.6588Z",
  fill: "#487C71"
});

function SvgTwitterNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNegative);
export default __webpack_public_path__ + "static/media/twitter-negative.743f199b.svg";
export { ForwardRef as ReactComponent };